import {
  ResponseInfoFeoroUsuario,
  ResponseInscribirseFeOro,
  ResponseVerFechaOro,
} from '@/types/goldDate';
import { ResponsePopupInscriptionData } from '@/types/tda';
import { axiosErrorHandler, TEXTS, URLs } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export const getInfoUsuarioOro = axiosErrorHandler(async () => {
  const url = `${URLs.FECHA_DE_ORO.INFO_USUARIO_ORO}`;

  const response = await axiosGdt.get<ResponseInfoFeoroUsuario>(url);
  return response.data;
}, TEXTS.defaultError);

export const popupInscriptionData = axiosErrorHandler(async () => {
  const url = `${URLs.FECHA_DE_ORO.DATOS_POPUP_INSCRIPCION}`;

  const response = await axiosGdt.get<ResponsePopupInscriptionData>(url);
  return response.data;
}, TEXTS.defaultError);

export const GoldDateRegistration = axiosErrorHandler(async (pin?: string) => {
  const url = `${URLs.FECHA_DE_ORO.INSCRIPCION}`;
  const params = `${pin ? `&pin=${pin}` : ''}`;

  const response = await axiosGdt.get<ResponseInscribirseFeOro>(url + params);
  return response.data;
}, TEXTS.defaultError);

export const requestViewGoldDate = axiosErrorHandler(async (id: number) => {
  const url = `${URLs.FECHA_DE_ORO.VER}`;
  const response = await axiosGdt.get<ResponseVerFechaOro>(
    `${url}&idTorneo=${id}`
  );
  return response.data;
}, TEXTS.defaultError);
